const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/NKIUBMK3z0w';

export function HeroHowItWorks() {
  return (
    <div className="relative w-full h-full">
      <iframe
        src={YOUTUBE_EMBED_URL}
        className="absolute inset-0 w-full h-full object-cover"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="How it works video"
      />
    </div>
  );
}
